import { MapZoomProps } from './types';
import useMapZoomStyles from './styles';
import { useKineticMap, useMapZoomButtonsState, useViewState } from 'components/maps';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';
import { MAX_ZOOM, MIN_ZOOM } from '../DeckGlMapContainer/const';
import { useCallback } from 'react';

export const MapZoom: React.FC<MapZoomProps> = (props) => {
  const { zoomButtonsPosition = 'bottom-left', topOffset = 0 } = props;
  const classes = useMapZoomStyles({ zoomButtonsPosition, topOffset });
  const map = useKineticMap();
  const { zoom } = useViewState(true);
  const { showZoomButtons } = useMapZoomButtonsState();

  const onZoomClick = useCallback(
    (zoomIn: boolean) => {
      const zoomValue = zoom ?? 0;
      if (zoomIn && zoomValue + 1 < MAX_ZOOM) {
        map.setZoom(zoomValue + 1);
      } else if (!zoomIn && zoomValue - 1 > MIN_ZOOM) {
        map.setZoom(zoomValue - 1);
      }
    },
    [map, zoom]
  );

  if (!showZoomButtons) {
    return null;
  }

  return (
    <ToggleButtonGroup orientation='vertical' size='small' className={classes.zoomButtonsWrapper}>
      <ToggleButton
        value={'zoomIn'}
        onClick={() => onZoomClick(true)}
        className={classes.zoomIconButton}
      >
        <Add className={classes.zoomIcon} />
      </ToggleButton>
      <ToggleButton
        value={'zoomOut'}
        onClick={() => onZoomClick(false)}
        className={classes.zoomIconButton}
      >
        <Remove className={classes.zoomIcon} />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
